/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState, useRef} from 'react';

// material
import {SortableList} from '@insticator/insticator-ui'; // iui-material

// styles
import injectSheet from 'react-jss';
import styles from './sortablelistsection_styles';

// components
import SectionGroup from "../../material/expandablesection/sectiongroup/sectiongroup";
import SectionGroupDescription
    from "../../material/expandablesection/sectiongroupdescription/sectiongroupdescription";


/* ========== ~~~~~~~~~~ SORTABLE LIST SECTION ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {
    // component props
    const {handleOnChange, formValues, options, field, title, description, skipValidation, errorMessage, disabled} = props;

    const selected = formValues[field] || [];

    const initialOrder = [...selected, ...options.filter(opt => !selected.includes(opt.value)).map(opt => opt.value)];

    const [indices, setIndices] = useState(initialOrder);

    // for keeping the height of the div when dragging the item
    const [height, setHeight] = useState(0)
    const draggerableWrapperRef = useRef(null);

    useEffect(() => {
        setHeight(draggerableWrapperRef.current.clientHeight)
    },[])

    const handleToggle = (order, value) => {
        if (selected.includes(value)) {
            handleOnChange({[field]: selected.filter(i => i !== value)})
        } else {
            handleOnChange({[field]: order.filter(i => selected.includes(i) || i === value)})
        }
    }

    const handleOrderChange = (order) => {
        setIndices(order)
        handleOnChange({[field]: order.filter(i => selected.includes(i))})
    }


    return (
        <SectionGroup>
            <SectionGroupDescription
                title={title}
                description={description}
            />
            <div ref={draggerableWrapperRef} style={{height: height ? height : null}}>
                <SortableList selected={selected}
                              order={indices || []}
                              items={options}
                              handleChange={(order, value) => handleToggle(order, value)}
                              handleOrderChange={(order) => handleOrderChange(order)}
                              error={{
                                    message: errorMessage,
                                    enabled: !skipValidation && !selected.length
                                }}
                              disabled={disabled}
                />
            </div>
        </SectionGroup>
    )
});
